import {Constants} from '@/shared/constants/commonConstants'

export const formatExtensionsLabel = (acceptedExtensions) =>
  acceptedExtensions.split(',').map((e) => e.trim()).join(' or ')

export const uploadFileDescriptionForCSV = ({acceptedExtensions} = {}) => {
  return (
    <div>
      <span>{Constants.DragAndDrop}</span>
      <br />
      <span>{acceptedExtensions ? `(${formatExtensionsLabel(acceptedExtensions)})` : Constants.OnlyCsv}</span>
    </div>
  )
}

export const uploadFileCSVError = () => {
  return (
    <div>
      <span>{Constants.UploadError}:</span>
      <br />
      <span>
        Your CSV file couldn’t be processed due to some formatting issues. Please check the following common errors and
        try again:
      </span>
      <br />
      <span>Missing Fields: Ensure all required columns (e.g., Name, Email, ID) are filled in.</span>
      <br />
      <span>Arrow Symbols: Remove any “→” symbols or special characters that might have been added.</span>
    </div>
  )
}

export const uploadImageCSVError = () => {
  return (
    <div>
      <span>{Constants.CorruptedFile}:</span>
      <br />
      <span>Make sure the image file is not corrupted or incomplete.</span>
    </div>
  )
}
